import { Component, OnInit } from '@angular/core';
import { Transition } from '@uirouter/angular';

import { TrainingService } from '../../../_services';
import { Training } from '../../../_services/training/training.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'jhi-trainings',
    templateUrl: 'detail.component.html',
    styleUrls: ['../training.component.scss', 'detail.component.scss'],
    providers: [TranslatePipe],
})
export class TrainingDetailComponent implements OnInit {
    private static _active: string = 'details';

    account: any;
    error: string;
    success: string;
    training: Training;
    trainingPicturePath = '';
    time = '';

    constructor(
        private trainingService: TrainingService,
        private trans: Transition
    ) {}

    get active(): string {
        return TrainingDetailComponent._active;
    }

    set active(active: string) {
        TrainingDetailComponent._active = active;
    }

    ngOnInit() {
        this.load(this.trans.params()['id']);
    }

    load(id: string) {
        this.trainingService.findById(id, true).subscribe((training) => {
            this.training = training;
            this.trainingPicturePath = training.picturePath;
        });
    }

    trainingPictureFromChild(trainingPicturePath) {
        this.trainingPicturePath = trainingPicturePath;
        this.updateTime();
    }

    updateTime() {
        this.time = new Date().getTime() + '';
    }

    toggleTab(selectedTab) {
        this.active = selectedTab;
    }

    onTrainingSaved(training: Training) {
        // Force the referesh of training values for this component's childs
        this.training = training;
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/training/detail/detail.component.ts